import React from "react";

const columns = [
  {
    title: 'API Name',
    dataIndex: 'api_name',
    key: 'api_name',
    width: 300,
  },
  {
    title: 'Message',
    dataIndex: 'message',
    key: 'message',
    render: (_, record) => {
      const lines = record.message?record.message.split("|"):[];
      return (
        <div>
          {lines && lines.length>0 && lines.map((line, index) => (
            <div key={index}>{line.trim()}</div>
          ))}
        </div>
      )
    },

  },
  {
    title: 'RequestBody',
    dataIndex: 'request_body',
    key: 'request_body',
    render: (_, record) => {
      const lines = record.request_body?record.request_body.split("|"):[];
      return (
        <div>
          {lines && lines.length>0 && lines.map((line, index) => (
            <div key={index}>{line.trim()}</div>
          ))}
        </div>
      )
    },

  },
 
  {
    title: 'User ID',
    dataIndex: 'user_id',
    key: 'user_id',
    width: 150,
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    width: 200,

  },
];
export default columns;
